const autoNumberSymbols = /[авекмнорстух]/i;
const INPUT_SETTINGS_MASK = {
    // ЛУчше привести к нашему стандарту
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'taxi-number': [
        [autoNumberSymbols, autoNumberSymbols, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/],
        [autoNumberSymbols, /\d/, /\d/, /\d/, ' ', autoNumberSymbols, autoNumberSymbols, ' ', /\d/, /\d/, /\d/],
    ],
    // ЛУчше привести к нашему стандарту
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'car-number': [
        autoNumberSymbols,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        ' ',
        autoNumberSymbols,
        autoNumberSymbols,
        ' ',
        /\d/,
        /\d/,
        /\d/,
    ],
    hidden: undefined,
    default: undefined,
};
const INPUT_SETTINGS_PLACEHOLDER = {
    // ЛУчше привести к нашему стандарту
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'taxi-number': 'Номер авто',
    // ЛУчше привести к нашему стандарту
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'car-number': 'A 000 AA 00',
    hidden: '',
    default: '',
};

export { INPUT_SETTINGS_MASK, INPUT_SETTINGS_PLACEHOLDER };
//# sourceMappingURL=inputSettings.js.map
